import React from 'react';

const SsoIcon = () => {
  return (
    <svg
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 269.5 252"
      width="24"
    >
      <g>
        <path d="M227.7,115.9c-5-11.1-14.7-18-20.1-21.1c0.1-7.8-1-24.6-11.5-36c-10.2-11.1-22.8-17.7-35.3-18.6   c-26.1-1.9-41.1,15-47.4,24.6C106.7,61,95.1,57,81.6,63c-14.8,6.6-18.3,21.7-18,31.8c-3.1,1.6-7.4,4.3-11.5,8.6   c-6.7,7.1-14.1,20-10.7,40.9c4.3,26.6,35.1,33,36.4,33.2l0.6,0.1l19.4,0.1l11.8-12l-29.9-0.2c-3.4-0.8-23.6-6.3-26.3-23.2   c-2-12.7,0.4-22.8,7.2-30.3c5.2-5.7,11.2-7.7,11.2-7.7l5-1.6l-0.9-5.2c0-0.2-2.8-17.6,10.6-23.6c13.5-6.1,24.4,3.4,24.8,3.8   l6.1,5.6l3.4-7.6c0.1-0.3,11.9-25.7,39-23.7c12.8,0.9,22.6,9.7,27.4,14.8c10.1,10.9,8.2,30.5,8.2,30.7l-0.5,4.4l4,1.8   c0.1,0.1,12.7,5.8,17.7,17c5.9,13.2,2.2,21.9,0.4,26c-0.3,0.8-0.6,1.4-0.8,2.1c-0.9,1.7-5.2,6.9-9.6,11.8c-1,1.1-1.9,2.2-2.9,3.2   l1.3,1.2l7.6,6.9c13.9-15.3,14.7-18.4,15-19.4c0.1-0.3,0.3-0.6,0.4-1.1C230.3,146.8,235.8,133.9,227.7,115.9z"/>
        <path d="M164.5,118.1c-16.5,0-30,13.4-30,30c0,3.6,0.6,7.1,1.8,10.3l-36.7,37.3l0.3,16.9l17.3,0.4l-0.2-10.8l10.4,0.1   l-0.2-10.9l10.9,0.3l15.6-15.6c3.3,1.3,6.9,1.9,10.6,1.9c16.5,0,30-13.4,30-30C194.5,131.6,181.1,118.1,164.5,118.1z M171.9,143.9   c-4.1,0-7.4-3.3-7.4-7.4c0-4.1,3.3-7.4,7.4-7.4s7.4,3.3,7.4,7.4C179.3,140.6,176,143.9,171.9,143.9z"/>
    </g>
  </svg>
  );
}

export default SsoIcon;



// WEBPACK FOOTER //
// ./src/components/Login/svg/SsoIcon.jsx